import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, map, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Auth0TokenService {
  constructor(public authService: AuthService) {}

  getTokens(): Observable<string> {
    return this.authService.isAuthenticated$.pipe(
      switchMap((isAuthenticated) => {
        if (isAuthenticated) {
          return this.authService
            .getAccessTokenSilently()
            .pipe(map((access) => access));
        } else {
          return of(null);
        }
      })
    );
  }
}
